export default {
  name: 'ConfirmModal',
  props: {
    title: {
      required: true,
      type: String
    },
    confirmLabel: {
      required: false,
      type: String,
      default: 'Подтвердить'
    },
    cancelLabel: {
      required: false,
      type: String,
      default: 'Отменить'
    }
  },

  methods: {
    open() {
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
    },
    confirm() {
      this.$emit('confirm');
      this.close();
    }
  }
};
